__turbopack_context__.v({
  "inlineTag": "style-module-scss-module__tCM7Mq__inlineTag",
});
